<template>
  <div class="featured-collection" :style="[paddingStyles, bgColorStyles]">
    <div
      class="featured-collection__carousel"
      :class="{'featured-collection__carousel--hover': hovered}"
    >
      <div class="controls-container">
        <div class="featured-collection__header">
          <div v-if="featuredCollection.enableHeadingLink" class="featured-collection__header">
          <a class="link link--secondary" :href="featuredCollection.headingLink!==''?featuredCollection.headingLink:'#'">
            <h1 v-if="featuredCollection.headingType && featuredCollection.headingType=='h1'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h1>
            <h2 v-if="featuredCollection.headingType && featuredCollection.headingType=='h2'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h2>
            <h3 v-if="featuredCollection.headingType && featuredCollection.headingType=='h3'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h3>
            <h4 v-if="featuredCollection.headingType && featuredCollection.headingType=='h4'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h4>
         </a>
        </div>
         <div v-else>
           <h1 v-if="featuredCollection.headingType && featuredCollection.headingType=='h1'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h1>
            <h2 v-if="featuredCollection.headingType && featuredCollection.headingType=='h2'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h2>
            <h3 v-if="featuredCollection.headingType && featuredCollection.headingType=='h3'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h3>
            <h4 v-if="featuredCollection.headingType && featuredCollection.headingType=='h4'" :class="featuredCollection.headingColor" v-html="featuredCollection.heading"></h4>
         </div>

        </div>
        <div class="featured-collection__subheader">
          <div>{{featuredCollection.subHeading}}</div>
        </div>

        <div class="featured-collection__view-all-button-container">
          <v-link
            v-if="featuredCollection.enableCta"
            :class="['featured-collection__view-all-button', featuredCollection.ctaLayout]"
            :href="featuredCollection.ctaLink"
            tag="a"
          > 
          <span v-html="featuredCollection.shopAllBtn" v-if="featuredCollection.shopAllBtn"></span>
          <span v-else >Shop All</span>

            
          </v-link>
        </div>
        <div class="arrows" v-if="!enableArrowHiding || filterProducts(featuredCollection.products).length >= MAX_PRODUCTS_FOR_ARROWS">
          <arrow-button
            primary
            left
            @click="slidePrev"
            label="Product Navigation Previous"
            class="button--arrow-primary button--left"
            :style="arrowIconBgColor"
            :disabled="leftArrowDisabled"
          />
          <arrow-button
            primary
            right
            @click="slideNext"
            label="Product Navigation Next"
            class="button--arrow-primary button--right"
            :style="arrowIconBgColor"
            :disabled="rightArrowDisabled"
          />
        </div>
      </div>
      <swiper
        :options="carouselOptions"
        ref="productImageCarousel"
        :class="{ 'swiper-no-swiping' : !shouldSwipe }"
      >
        <swiper-slide
          v-for="(product, index) in filterProducts(featuredCollection.products)"
          :key="`product-${index}`"
        >

          <div @mouseover="hovered = true" @mouseleave="hovered = false">
            <product-tile
              class="featured-product-tile"
              :simple="isSimpleProductTile"
              :product="product"
              :onAddToCart="addToCart"
              :showMobileATC="showMobileATC"
              :collection-template="collectionTemplate"
              :text-alignment="productTileTextAlignment"
              :enable-simple-tile-cta="enableSimpleTileCta"
            />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue';
import ProductTile from '@/scripts/components/product/ProductTile.vue';
import css from 'swiper/swiper-bundle.min.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import VButton from '@/scripts/components/buttons/VButton.vue';
import VLink from '@/scripts/components/buttons/VLink.vue';
import ArrowButton from '@/scripts/components/buttons/ArrowButton.vue'
import { isHiddenProduct, checkUndefined } from '@/scripts/helpers/util';
import { px } from '@/scripts/filters/string.js';

const cssVars = require('@/styles/variables.scss');

export default {
  name: 'FeaturedCollection',
  components: {
    ProductTile,
    swiper,
    swiperSlide,
    Icon,
    VButton,
    VLink,
    ArrowButton,
  },
  props: {
    collectionTemplate: String,
    productTileTextAlignment: String,
    showMobileATC: ProductTile.props.showMobileATC,
    featuredCollection: {
      type: Object,
      default: () => ({
        heading: {
          type: String,
          required: true,
        },
        shopAllBtn:{
          type: String,
          required: false,
        },
        products: {
          type: Array,
          required: true,
        },
      }),
    },
    enableArrowHiding: {
      type: Boolean,
      default: false,
    },
    enableSimpleTile: {
      type: Boolean,
      required: true,
    },
    enableSimpleTileCta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MAX_PRODUCTS_FOR_ARROWS: 5,
      slidesPerView: {
        hd: '3.282',
        desktop: '3.282',
        tablet: '3.282',
        mobile: '1.8665',
      },
      hovered: false,
      leftArrowDisabled: true,
      setLeftArrowDisabled: (isDisabled) => {
        return this.leftArrowDisabled = isDisabled;
      },
      rightArrowDisabled: false,
      setRightArrowDisabled: (isDisabled) => {
        return this.rightArrowDisabled = isDisabled;
      }
    };
  },
  computed: {
    bgColorStyles () {
      return {
        background: this.featuredCollection.bgColor
      }
    },
    arrowIconBgColor () {
      return {
        background: this.featuredCollection.arrowColor
      }
    },
    swiperDesktop() {
      return this.$refs.productImageCarousel.swiper;
    },
    carouselOptions() {
      const setLeftDisabled = this.setLeftArrowDisabled;
      const setRightDisabled = this.setRightArrowDisabled;
      return {
        slidesPerView: 'auto',
        threshold: 5,
        loop: false,
        speed: 1000,
        on: {
          slideChange: function () {
            if (this.params.slidesPerView) {
              // Get length of array of non duplicate slides
              const numOfSlides = Array.from(this.slides).filter(
                (el) => !el.matches('.swiper-slide-duplicate')
              ).length;
              // if swiper is near the last slide the right arrow should be disabled
              // - 1 because last slide will go out of view otherwise
              if (this.realIndex >= numOfSlides - 1) {
                setRightDisabled(true);
              // when swiper is on the first slide the left arrow should be disabled
              } else if (this.realIndex <= 0) {
                setLeftDisabled(true);
              // else nothing should be disabled
              } else {
                setLeftDisabled(false);
                setRightDisabled(false);
              }
            }
          },
        },
      };
    },
    shouldSwipe() {
      return (
        this.slidesPerView[this.$mq] <
        this.filterProducts(this.featuredCollection.products).length
      );
    },
    isSimpleProductTile() {
      return this.collectionTemplate === 'b' || this.enableSimpleTile;
    },
    paddingStyles() {
      return {
        'padding-top': px(
          checkUndefined(this.featuredCollection.marginTop, 56)
        ),
        'padding-bottom': px(
          checkUndefined(this.featuredCollection.marginBottom, 56)
        ),
        'justify-content': 'center',// for whole carousel max-width.
        'overflow': 'hidden'// for whole carousel max-width

      };
    },
  },
  methods: {
    filterProducts(products) {
      console.log(window.bvaccel.b2b,"window.bvaccel.b2b")
      return products.filter(
      (prod) => prod.available && !isHiddenProduct(prod) &&
      (window.bvaccel.b2b ? prod.tags.includes('wholesale') : !prod.tags.includes('wholesale'))
);
      
    },
    slidePrev() {
      if (this.shouldSwipe) {
        this.swiperDesktop.slidePrev();
      }
    },
    slideNext() {
      if (this.shouldSwipe) {
        this.swiperDesktop.slideNext();
      }
    },
    addToCart(id) {
      const addProduct = {
        id: id,
        quantity: 1,
      };
      this.$store
        .dispatch('cart/addItems', addProduct)
        .then(() => this.$store.dispatch('cart/afterAddToCart'))
        .catch((error) =>
          this.$store.dispatch('toast/send', { text: error, type: 'error' })
        )
        .then(() => (this.adding = false));
    },
  }
};
</script>

<style scoped lang="scss">
.featured-collection {
  overflow-clip-box: padding-box;
  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2px; // The header position.
    @include mobile-only {
      margin-bottom: 16px;
    }
    
    div, h4,h1 {
      text-transform: none;
      line-height: rem(34);
      @include mobile-only {
        font-size: 1.25rem;
      }
      @include tablet-up {
        font-size: rem(35);
        line-height: rem(48);
      }
    }
  }
  &__subheader {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    height: 19px;
  }
  .controls-container {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: -40px;
    position: relative;
    z-index: 2;
    width: 95%;
    @include mobile-only {
      width: 95%;
    }
    .arrows {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      width: fit-content;
      position: absolute;
      top: 19px; // The carousel arrow position
      *:first-child {
        margin-right: 16px;
      }
      @include mobile-only {
        display: none;
      }
    }
  }
  &__view-all-button-container {
    display: flex;
    position: relative;
    justify-content: flex-end;
    top: -57px; // The Shop All text position

    @include mobile-only {
      top: -47px;
    }
  }
}
.featured-collection__carousel .swiper-container {
  padding-bottom: 0px; // whole carousel box bottom

  @include tablet-up {
    padding-bottom: 32px;
  }

  @include mobile-only {
      padding-top: 0px;
      // margin-left:25px;
  }

  .template-index &,
  .template-product & {
    @include tablet-up {
      padding-bottom: 0px; // whole carousel position.
      padding-left: 0px; // whole carousel position.
    }
  }
}


.featured-collection__carousel {
  position: relative;
  z-index: 3;
  margin: 0 auto;
  max-width: 1100px; // whole carousel max-width.

  @include tablet-up {
    margin-bottom: 20px;
    padding-bottom: 0;
  }
}

.featured-collection__carousel--hover {
  z-index: 5;
}

/deep/ .product-tile {
  padding: 0;
  background-color: #F7F7F6;
  transition: box-shadow 300ms ease;
  @include tablet-up {
    height: 375px; // each carousel box height
  }

  .product-tile__static-text-content {
    @include mobile-only {
      bottom: 5px; // distance between the text and the bottom of the carousel box.
    }
  }

  .product-tile-title {
    color: $color-black-eclipse2;
    font-size: rem(14);
    line-height: rem(15);
    white-space: normal;
  }

  .product-tile-vendor-name {
    @include mobile-only {
      font-size: rem(11);
      line-height: rem(12);
      color: $color-dark-grey;
      white-space: normal;
    }
  }

  &:hover {
    @include mobile-only {
      box-shadow: none;
    }
    @include tablet-only {
      box-shadow: none;
    }
  }
}

.arrows:focus,
.arrows:hover {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

/deep/ .swiper-container {
  z-index: auto;

  @include desktop-up {
    padding-bottom: 4px;
  }
}

/deep/ .swiper-wrapper {
  align-items: stretch;
}

/deep/ .swiper-slide {
  padding-left: 2px;
  padding-right: 2px;
  height: auto;
  background-color: #FFFFFF;
  width: 205px;
  @include tablet-up {
    padding-left: 4px;
    padding-right: 4px;
    width: 219px; // each carousel box width
    margin: 0;
  }
}

.swiper-slide-duplicate {
  opacity: 0;
  visibility: hidden;
}

.expert__feature-collection .swiper-container {
  @include tablet-up {
    padding-left: 236px;
  }
}
</style>
